module.exports = __webpack_public_path__ + "static/christina-yacht-1-a337aa6690fd33a1be2c93a148afe248.jpg";